"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
const AiCalculatorPopup = dynamic(() => import("../ai-calculator-popup/ai-calculator-popup"), {
  ssr: false
});
const GlossaryTermClientContent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><AiCalculatorPopup /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default GlossaryTermClientContent;